<div class="success-dialog">
    <div class="top-right-x">
        <i class="fal fa-times" (click)="topRightXClicked()"></i>
    </div>
    <div class="success-icon">
        <i class="fas fa-check-circle"></i>
    </div>
    <div class="success-title">
        {{ title }}
    </div>
    <div class="success-message">
        {{ message }}
    </div>
    <div class="success-buttons">
        <button mat-button outlined class="btn-button" (click)="editClicked()" type="button">
            EDIT
        </button>
        <button mat-button primary class="btn-button" (click)="viewClicked()" type="button">
            VIEW
        </button>
    </div>
</div>
